export const COMPANY_ACTION = {
  GET_COMPANY_LIST: "GET_COMPANY_LIST_COMPANY_ACTION",
};
